export default __webpack_public_path__ + "static/media/2021 knife block A side.4328c0bc.png";